import { useMemo } from 'react';
import { useNavbarBackButton } from './useNavbarBackButton';
import { useNavbarTitle } from './useNavbarTitle';
import { useNavbarFavoriteButton } from './useNavbarFavoriteButton';
import { useNavbarFilterButton } from './useNavbarFilterButton';

export const useNavbarItems = () => {
  const backButton = useNavbarBackButton();
  const title = useNavbarTitle();
  const favoriteButton = useNavbarFavoriteButton();
  const filterButton = useNavbarFilterButton();

  const items = useMemo(
    () => [backButton, title, favoriteButton, filterButton].filter(Boolean),
    [backButton, title, favoriteButton, filterButton]
  );

  return items;
};
